import { render, staticRenderFns } from "./registerStore.vue?vue&type=template&id=c77d4e5a&scoped=true&"
import script from "./registerStore.vue?vue&type=script&lang=js&"
export * from "./registerStore.vue?vue&type=script&lang=js&"
import style0 from "./registerStore.vue?vue&type=style&index=0&id=c77d4e5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77d4e5a",
  null
  
)

export default component.exports